module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-alia.bc69c1e1.jpeg";